import React, {useEffect, useState} from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import { confirmAlert } from 'react-confirm-alert';
import {ButtonTableDelete, ButtonTableEdit} from "../../../components/buttons/buttonsActions";
import { showLoader } from "../../../components/loader/loader";
import { utilHelper } from "../../../jwt/_helpers";
import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    LIST,
    NO,
    NO_DATA_FOUND,
    YES
} from "../../../components/i18n/i18n";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import {typeDestinationActivityService} from "../../../jwt/_services/xailing/typeDestinationActivityService";

export default function TypeDestinationActivityList(props) {
    const [sizePerPage, setSizePerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [totalSize, setTotalSize] = useState(10);
    const [listItems, setListItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        refreshDataList(page, currentIndex, sizePerPage);
    }, []);

    const handleTableChange = (type, {page, sizePerPage}) => {
        let index = (page - 1) * sizePerPage
        refreshDataList(page, index, sizePerPage);
    };

    const refreshDataList = (page, currentIndex, sizePerPage) => {
        setLoading(true);
        typeDestinationActivityService.search(currentIndex, sizePerPage)
            .then(result => {
                if (result){
                    setListItems(result.data);
                    setTotalSize(result.total);
                    setCurrentIndex(currentIndex);
                    setPage(page);
                    setSizePerPage(sizePerPage);
                } else {
                    setListItems([]);
                    setTotalSize(0);
                    setCurrentIndex(0);
                    setPage(1);
                    setSizePerPage(10);
                }
                setLoading(false);
            })
            .catch(_ => {
                setLoading(false);
                setListItems([]);
                setTotalSize(0);
                setCurrentIndex(0);
                setPage(1);
                setSizePerPage(10);
            });
    }

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        setLoading(true);
        typeDestinationActivityService.deleteItem(data.id)
            .then(_ => {
                setLoading(false);
                refreshDataList(page, currentIndex, sizePerPage);
                if (utilHelper.hasAssociateRecords()) {
                    utilHelper.restartAssociateRecords();
                }
            });
    }

    const editItem = (data) => {
        const itemToEdit = listItems.find(n => n.id === data.id);
        props.setForm(true, itemToEdit, "FORM");
    }


    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <ButtonTableDelete onClick={() => confirmDelete(row)}/>
                <ButtonTableEdit onClick={() => editItem(row)}/>
            </div>
        );
    }

    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }


    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'code',
        text: 'Código',
    }, {
        dataField: 'name',
        text: 'Nombre',
    }, {
        dataField: 'showOrder',
        text: 'Orden',
    }, {
        dataField: 'status',
        text: "Activo",
        formatter: activeFormatter
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '240px'},
        formatter: actionsFormatter
    }];

    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-list-alt mr-2"> </i>{LIST}
            </CardTitle>
            <CardBody className="">
                {loading && showLoader()}
                <BootstrapTable
                    striped hover
                    tableHeaderClass='mb-0'
                    remote
                    keyField="id"
                    data={listItems}
                    columns={columns}
                    noDataIndication={NO_DATA_FOUND}
                    pagination={paginationFactory({page, sizePerPage, totalSize})}
                    onTableChange={handleTableChange}
                />
            </CardBody>
        </Card>
    )
}